/**
 * Simple undo/redo stack for user markup lists (JSON snapshots).
 */

const MAX_HISTORY = 50;

export function createMarkupHistory() {
  return { past: [], future: [] };
}

export function pushMarkupSnapshot(history, markups) {
  if (!history) return;
  history.past.push(JSON.stringify(markups));
  if (history.past.length > MAX_HISTORY) {
    history.past.shift();
  }
  history.future = [];
}

export function undoMarkupSnapshot(history, currentMarkups) {
  if (!history?.past?.length) return null;
  history.future.push(JSON.stringify(currentMarkups));
  const prev = history.past.pop();
  try {
    return JSON.parse(prev);
  } catch {
    return null;
  }
}

export function redoMarkupSnapshot(history, currentMarkups) {
  if (!history?.future?.length) return null;
  history.past.push(JSON.stringify(currentMarkups));
  const next = history.future.pop();
  try {
    return JSON.parse(next);
  } catch {
    return null;
  }
}

export function canUndoMarkup(history) {
  return Boolean(history?.past?.length);
}

export function canRedoMarkup(history) {
  return Boolean(history?.future?.length);
}
